import { useSearchParams } from 'react-router-dom';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getProjectOverChannelColorCssVariable from '@/utils/colors/get-project-over-channel-color-css-variable';

const NoAudienceLists = () => {
  const [searchParams] = useSearchParams();
  const hasFilters = !!searchParams.get('search');

  return (
    <Container className="flex fd-column ai-center jc-center gap-8" height="200px">
      <Text className="H3" color={getProjectOverChannelColorCssVariable(EColorVariablesV2.primary, 'global-cont-1')}>
        {hasFilters ? 'No lists match your search' : 'No lists have been added'}
      </Text>
      <Text className="S1" design="GlobalIcoText2">
        {hasFilters
          ? 'Try adjusting your search criteria.'
          : 'Add an existing list or create a new one to get started.'}
      </Text>
    </Container>
  );
};

export default NoAudienceLists;
